<style lang="scss">
  @import '../resources/scss/partners.scss';
</style>

<script lang="ts">
  import type Partner from '../api/rest/directus-cms/app/models/Partner'
  import type PartnerSection from '../api/rest/directus-cms/app/models/PartnerSection'
  import { commonWebsiteData } from '../stores/stores'

  let partnersData: PartnerSection | undefined
  $: partnersData = $commonWebsiteData?.partners_section
  let countryPartners: Array<Partner>
  $: countryPartners = (partnersData?.partners ?? [])
    .filter(partner => partner.isCountry)
    .sort(sortAlphabetically)
  let nonCountryPartners: Array<Partner>
  $: nonCountryPartners = (partnersData?.partners ?? [])
    .filter(partner => !partner.isCountry)
    .sort(sortAlphabetically)

  function sortAlphabetically(a: Partner, b: Partner) {
    return a.name.localeCompare(b.name)
  }
</script>

{#if partnersData}
  <div class="container-fluid bg-white">
    <div class="container-xxl py-5">
      <div class="grid-flags gap-4">
        <div class="title d-flex flex-column justify-content-center align-items-center">
          <h5 class="text-neutral-b mb-0">{partnersData.title}</h5>
        </div>
        {#each countryPartners as partner}
          <div class="flag d-flex flex-column justify-content-between align-items-center">
            <img src={partner.image?.fullUrl} alt={partner.name} />
            <span class="h6 mt-2 text-primary-orange text-center">{partner.name}</span>
          </div>
        {/each}
      </div>
      <div class="grid-partners mt-4 gap-3">
        {#each nonCountryPartners as partner}
          <div
            class="partner border rounded d-flex justify-content-center align-items-center"
          >
            <img src="{partner.image?.fullUrl}?height=56" alt={partner.name} />
          </div>
        {/each}
      </div>
    </div>
  </div>
{/if}
